import React, { useEffect, useState } from "react";
import { Breadcrumb, Button } from "react-bootstrap";
import FormInput from "lib/formInputs";
import { useNavigate } from "react-router-dom";
import { useCommonSortFilterHook } from "hooks/common/useCommonSortFilterHook";
import SearchBox from "components/TableHeader/SearchBox";
import { PATHS } from "configs/routeConfig";
import { getTimeDifference, messageNotification, organizeNotificationsTime, formatDateTime } from "utils/functions";
import { useProfileHook } from "hooks/profile/useProfileHook";
import CommonPagination from "lib/pagination/CommonPagination";
const Notifications = () => {
  const {
    currentPage,
    pageSize,
    search: staticPageSearch,
    onSearch,
    onUpdatePage,
  } = useCommonSortFilterHook("notifications");

  const {
    getNotificationsList,
    getNotificationsListData,
    isGetNotificationsListUninitialized,
    updateNotificationStatus,
    globalConfigData,
  } = useProfileHook();

  const navigate = useNavigate();
  const [notificationIds, setNotificationIds] = useState([]);

  const handleSearch = (searchString) => {
    onSearch(searchString);
    fetchNotificationsListAsync();
  };

  const fetchNotificationsListAsync = async () => {
    await getNotificationsList({
      page: currentPage.current,
      pageSize: pageSize.current,
      searchText: staticPageSearch.current,
    });
  };

  useEffect(() => {
    fetchNotificationsListAsync();
  }, []);

  const updatePage = (page, limit) => {
    onUpdatePage(page, limit);
    fetchNotificationsListAsync();
  };

  const handleNotificationStatus = async () => {
    const response = await updateNotificationStatus({
      ids: getNotificationsListData?.data?.map((notification) => notification?._id) || notificationIds,
      isRead: true,
      markAll: true,
    });

    if (response?.data?.status) {
      messageNotification("All notifications marked as read", "success");
    }
  };

  const handleNotificationClick = async (notification) => {
    const navigationRoute = JSON.parse(notification?.data);

    if (navigationRoute?.type === "assessment" || navigationRoute?.type === "wound") {
      navigate(`/${PATHS.WOUND_LISTING}/${navigationRoute?.type}/${navigationRoute?._id}`);
    } else if (navigationRoute?.type === "patient") {
      navigate(`${PATHS.USER}/${PATHS.USER_LIST}/${"view"}/${navigationRoute?._id}`);
    }

    if (!notification.isRead) {
      const updatedIds = [...notificationIds, notification._id];
      setNotificationIds(updatedIds);
      await updateNotificationStatus({
        ids: updatedIds,
        isRead: true,
        markAll: false,
      });
    }
  };

  // Group notifications using the function
  const groupedNotifications = organizeNotificationsTime(getNotificationsListData?.data || [], globalConfigData);

  return (
    <div className="pb-16 notification-page">
      <div className="flex-between-middle flex-md-row flex-column mt-16 mb-30">
        <h2 className="h1 mb-md-0">Notifications</h2>
        <Breadcrumb>
          <Breadcrumb.Item onClick={() => navigate(`${PATHS.DASHBOARD}`)}>Dashboard</Breadcrumb.Item>
          <Breadcrumb.Item href="#" className="active">
            Notifications
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-20">
        <div className="relative">
          <div className="table-card-header">
            <SearchBox setSearch={handleSearch} search={staticPageSearch.current} className="m-0" />
          </div>
          <FormInput placeholder="Search" className="pl-10" />
        </div>
        <Button variant="link" className="text-blue-600" onClick={handleNotificationStatus}>
          Mark all as read
        </Button>
      </div>

      <ul>
        {groupedNotifications?.map((group, index) => {
          const [section, notifications] = Object.entries(group)[0]; // Extract key-value pair
          return (
            <>
              <li className="notification-header">{section}</li>
              {notifications?.map((notification) => (
                <li
                  key={notification?._id}
                  className="notification"
                  onClick={() => handleNotificationClick(notification)}
                >
                  <div className="notification-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M6 8.5H18M16 12.5H6M3 16V5C3 4.44772 3.44772 4 4 4H20C20.5523 4 21 4.44772 21 5V16C21 16.5523 20.5523 17 20 17H6.75L3.16247 19.87C3.09699 19.9224 3 19.8758 3 19.7919V16Z"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                    </svg>
                  </div>
                  <div className="notification-content w-100 me-8">
                    <h6 className="notification-title">{notification?.title}</h6>
                    <p className="notification-message">{notification?.body}</p>
                  </div>
                  <div className="notification-status d-flex justify-content-end w-100">
                    <span className="notification-time">
                      {section === "Today"
                        ? getTimeDifference(notification?.createdAt)
                        : formatDateTime(notification?.createdAt, globalConfigData)}
                    </span>
                    {!notification?.isRead ? (
                      <span className="notification-badge"></span>
                    ) : (
                      <span className="notification-badge notification-empty"></span>
                    )}
                  </div>
                </li>
              ))}
            </>
          );
        })}
      </ul>

      {!isGetNotificationsListUninitialized && (
        <CommonPagination
          updatePage={updatePage}
          total={getNotificationsListData?.total || 0}
          className="justify-content-end"
          module="notifications"
        />
      )}
    </div>
  );
};

export default Notifications;
